import { ESellerDisableReason } from 'models/seller'

export interface ISellerDisableState {
  is_disabled?: boolean
  disabled_reasons?: ESellerDisableReason[]
}

const HIDING_REASONS = [
  ESellerDisableReason.MANUAL,
  ESellerDisableReason.CANCELS,
  ESellerDisableReason.PROFILE_INCOMPLETE
]

// is_disabled без причин — запись до разметки причин, бэкенд считает её скрытой вручную
export const getSellerDisableReasons = ({
  is_disabled: isDisabled,
  disabled_reasons: reasons
}: ISellerDisableState): ESellerDisableReason[] => {
  if (reasons?.length) return reasons
  return isDisabled ? [ESellerDisableReason.MANUAL] : []
}

// Скрытый магазин отдаёт 404 на карточках. Отключённый только за остатки
// не скрыт: карточки открываются, но купить нельзя
export const isSellerHidden = (seller: ISellerDisableState) =>
  getSellerDisableReasons(seller).some((reason) => HIDING_REASONS.includes(reason))
